
import Vue from 'vue';
import UpdateAccountEmailForm from '../../components/account/UpdateAccountEmailForm.vue';
import { ACTIONS } from '../../constants/actions';
import { Profile } from '../../store/modules/profile/profile.module';
import BackButton from '../../components/common/BackButton.vue';

export default Vue.extend({
  components: { UpdateAccountEmailForm, BackButton },
  name: 'UpdateAccountEmail',
  methods: {
    updateEmail(event: Partial<Profile>): void {
      const { dispatch } = this.$store;
      dispatch(ACTIONS.profile.updateProfile, { profile: event }).then(() => this.$router.back());
    }
  }
});
